import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default","error"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/public/assets/css/supplier/supplier-detail.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Currency.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/icon.tsx");
